import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-plus';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import { Button } from 'modules/theme';
import { ControlLabel, FormControl } from 'modules/theme';
import { router, searchCompany } from 'modules/common/utils';
import { Alert } from 'modules/theme';
import Toggle from 'react-toggle';
import { FormWrapper, FormColumn, ModalFooter } from 'modules/theme';
import { ModalTrigger, FormGroup } from 'modules/theme';
import { modalType } from '../../../../../helpers/dotenv';
import APIManager from 'modules/common/apiManager';
import { FlexItem, FlexRow, InsightFilter, ItemSearch } from '../styles/main';
import { KIND_CHOICES as INTEGRATIONS_TYPES, timezones } from './timezones';

var uuid = require('uuid');
let { REACT_APP_API_URL } = process.env;
let tAPI = localStorage.getItem('REACT_APP_API_URL');
if (
  tAPI &&
  typeof tAPI !== 'undefined' &&
  tAPI !== 'undefined' &&
  tAPI !== ''
) {
  REACT_APP_API_URL = tAPI;
}

const propTypes = {
  brands: PropTypes.array.isRequired,
  queryParams: PropTypes.object,
  history: PropTypes.object
};

const contextTypes = {
  __: PropTypes.func,
  closeModal: PropTypes.func
};

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let zone = {};
    var timeZone = moment.tz.guess();
    zone.value = timeZone;
    zone.label = zone.value;
    if (window.localStorage && window.localStorage.getItem('timezone')) {
      zone = JSON.parse(window.localStorage.getItem('timezone'));
    }
    if (zone === null) {
      timeZone = moment.tz.guess();
      zone = {};
      zone.value = timeZone;
      zone.label = zone.value;
    }
    this.currentTimestamp =
      parseInt(
        moment()
          .tz(zone.value)
          .format('X')
      ) * 1000;
    this.dayBeforeTimeStamp =
      parseInt(
        moment()
          .subtract(1, 'days')
          .tz(zone.value)
          .format('X')
      ) * 1000;
    this.state = {
      ...props.queryParams,
      // check condition for showing placeholder
      showFilterButton: this.props.showFilter || true,
      startDate: this.currentTimestamp,
      endDate: this.currentTimestamp,
      isChange: false,
      CampaignList: [],
      projects: [],
      selectedCampaign: [],
      selectedSenderList: {value: "", label: ""},
      senderList: [{_id: "All Sender", name: "All Sender"}, {_id: "SEPLPS", name: "SEPLPS"}, {_id: "TCL", name: "TCL"}],
      selectedFilter: null,
      formatDate: '',
      freeTextSearch: null,
      filterName: null,
      filterNameUpdate: null,
      _id: '',
      fromSelector: null,
      toSelector: null,
      GroupBy: null,
      isNew: true,
      toshowGroupby: 0,
      DatesBy: null,
      showStartEndDate: false,
      selectedColumns: [],
      timezone: zone,
      showHide: false,
      modalType: modalType,
      TeamList: [],
      selectedTeam: [],
      UserList: [],
      selectedUser: [],
      dateDropdownOptions: []
    };
    this.handleProjectSearch = this.handleProjectSearch.bind(this);
    this.checkField = this.checkField.bind(this);
    this.onClick = this.onClick.bind(this);
    this.resetAllData = this.resetAllData.bind(this);
    this.handleTeamSearch = this.handleTeamSearch.bind(this);
    this.handleUserSearch = this.handleUserSearch.bind(this);
    this.handleDateDropdown = this.handleDateDropdown.bind(this);
    this.getTeam();
    this.getCampaign();
    this.getUser();
  }

  componentDidMount() {
    this.handleDateDropdown();
    this.handleProjectSearch();
    this.handleTeamSearch();
    this.handleUserSearch();
    this.handleSenderSelect();
    if (window.localStorage) {
      if (!window.localStorage.getItem('timezone')) {
        window.localStorage.setItem(
          'timezone',
          JSON.stringify(this.state.timezone)
        );
        console.log('here', window.localStorage.getItem('timezone'));
      }
    }
    else {
      this.setState({ toshowGroupby: 0 });
    }
    console.log(this.state.toshowGroupby);
  }

  componentWillReceiveProps(nextProps) {
    let result = nextProps.getSelectedColumnNames();
    this.setState({
      selectedColumns: result
    });
    let zone = {};
    if (window.localStorage && window.localStorage.getItem('timezone')) {
      zone = JSON.parse(window.localStorage.getItem('timezone'));
    } else {
      zone = { value: 'America/New_York', label: 'America/New_York' };
    }
    if (
      nextProps.selectedFilter &&
      typeof nextProps.selectedFilter.filterName !== 'undefined' &&
      (typeof this.props.selectedFilter === 'undefined' ||
        nextProps.selectedFilter.filterName !==
        this.props.selectedFilter.filterName)
    ) {
      if (
        nextProps.selectedFilter.filterJson &&
        nextProps.selectedFilter.filterJson.GroupBy &&
        typeof nextProps.selectedFilter.filterJson.GroupBy !== 'undefined'
      ) {
        if (nextProps.selectedFilter.filterJson.DatesBy !== 'Custom Date') {
          this.setState({
            showStartEndDate: false
          });
        } else {
          this.setState({
            showStartEndDate: true
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === '' ||
          nextProps.selectedFilter.filterJson.endDate === '' ||
          nextProps.selectedFilter.filterJson.timezone === '' ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          console.log(this.dayBeforeTimeStamp);
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: zone
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: nextProps.selectedFilter.filterJson.timezone || zone
          });
        }
        console.log(this.state.GroupBy);
      } else {
        if (nextProps.selectedFilter.filterJson.DatesBy !== 'Custom Date') {
          this.setState({
            showStartEndDate: false
          });
        } else {
          this.setState({
            showStartEndDate: true
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === '' ||
          nextProps.selectedFilter.filterJson.endDate === '' ||
          nextProps.selectedFilter.filterJson.timezone === '' ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          let zone = {};
          if (window.localStorage && window.localStorage.getItem('timezone')) {
            zone = JSON.parse(window.localStorage.getItem('timezone'));
          } else {
            zone = { value: 'America/New_York', label: 'America/New_York' };
          }
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: zone
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: nextProps.selectedFilter.filterJson.timezone || zone
          });
        }
      }
    }
  }

  handleDateDropdown() {
    if(this.props.history.location.pathname !== "/campaign") {
      this.setState({dateDropdownOptions: [
      'Today',
      'Last 24 Hrs',
      'Yesterday',
      'Last Week',
      'Custom Date']
    })
    }else {
      this.setState({dateDropdownOptions: [
      'Today',
      'Custom Date']
      })
    }
  }

  handleProjectSearch(value) {
    searchCompany(value, CampaignList => this.setState({ CampaignList }));
  }

  handleTeamSearch(value) {
    searchCompany(value, TeamList => this.setState({ TeamList }));
  
  }
  handleUserSearch(value) {
    searchCompany(value, UserList => this.setState({ UserList }));
  }

  handleSenderSelect(value) {
    searchCompany(value, SenderList => this.setState({ SenderList }));
  }

  onFilterByDate(type, date) {
    if (this.state.isChange) {
      const formatDate = date ? moment(date).format('YYYY-MM-DD HH:mm') : null;
    }
  }



  getCampaign() {
    var that = this;
    // this.mAPI.sendGetAPI(
    //   `campaign?limit=100&page_no=1`,
    //   data => {
    //     // console.log(JSON.stringify(data, null, 2));
    //     if (data && data.data) {
    //       that.setState({ CampaignList: data.data });
    //     }
    //   },
    //   (error, data) => {
    //     console.log(`Error:`, error);
    //     // if (data) {
    //     //   Alert.error(`${data.message}`);
    //     // } else {
    //     //   Alert.error(`${error}`);
    //     // }
    //   }
    // );
  }

  getTeam() {
    var that = this;
    // this.mAPI.sendGetAPI(
    //   `team/list?limit=100&page_no=1&filterValue=true&filterVariableValueType=boolean`,
    //   data => {
    //     // console.log(JSON.stringify(data, null, 2));
    //     if (data && data.data) {
    //       that.setState({ TeamList: data.data });
    //     }
    //   },
    //   (error, data) => {
    //     console.log(`Error:`, error);
    //     // if (data) {
    //     //   Alert.error(`${data.message}`);
    //     // } else {
    //     //   Alert.error(`${error}`);
    //     // }
    //   }
    // );
  }

  getUser() {
    var that = this;
    // this.mAPI.sendGetAPI(
    //   `user?limit=100&page_no=1`,
    //   data => {
    //     // console.log(JSON.stringify(data, null, 2));
    //     if (data && data.data) {
    //       that.setState({ UserList: data.data });
    //     }
    //   },
    //   (error, data) => {
    //     console.log(`Error:`, error);
    //     // if (data) {
    //     //   Alert.error(`${data.message}`);
    //     // } else {
    //     //   Alert.error(`${error}`);
    //     // }
    //   }
    // );
  }

  onClick = () => {
    let tData = Object.assign({}, this.state);
    // if (tData.selectedCampaign && tData.selectedCampaign.length < 1) {
    //   // tData.selectedCampaign = this.generateProjectParams(tData.projects) ;
    //   tData.selectedCampaign = tData.projects;
    // }
    this.props.getData(tData);
  };

  generateProjectParams(tData) {
    return tData.map(data => ({
      value: data._id,
      label: data.name || ''
    }));
  }

  renderTimezones() {
    const { __ } = this.context;
    var that = this;
    return (
      <FlexItem>
        <ControlLabel>TIMEZONE</ControlLabel>
        <Select
          placeholder={__('Search')}
          clearable={false}
          onChange={selectedOption => {
            if (selectedOption && selectedOption !== null) {
              window.localStorage.setItem(
                'timezone',
                JSON.stringify(selectedOption)
              );
              let x = JSON.parse(window.localStorage.getItem('timezone'));
              that.setState({
                timezone: x
              });
            }
          }}
          value={this.state.timezone}
          options={timezones}
        />
      </FlexItem>
    );
  }

  renderCampaign() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Campaign</ControlLabel>
        <Select
          placeholder={__('Search')}
          onFocus={() => this.handleProjectSearch('')}
          onInputChange={this.handleProjectSearch}
          onChange={selectedOption => {
            this.setState({
              selectedCampaign: selectedOption
            });
          }}
          value={this.state.selectedCampaign}
          options={this.generateProjectParams(this.state.CampaignList)}
          multi
        />
      </FlexItem>
    );
  }

  renderFormGroup(label, props) {
    return (
      <FlexItem>
        <ItemSearch>
          <ControlLabel>{label}</ControlLabel>
          <FormControl
            type="text"
            // placeholder={__('Type to search')}
            // onChange={e =>
            //   this.setState({ freeTextSearch: e.target.value })
            // }
            // value={this.state.freeTextSearch}
            {...props}
          />
        </ItemSearch>
      </FlexItem>
    );
  }

  handleChange(event) {
    this.setState({ filterName: event.currentTarget.value });
  }

  generateEntitysParams(supportedEntityList) {
    return supportedEntityList.map(entity => ({
      value: entity,
      label: entity
    }));
  }
  renderFrom() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('From', {
              defaultValue: '',
              placeholder: '',
              required: true,
              id: 'from',
              value: this.state.fromSelector,
              onChange: e => {
                this.setState({ fromSelector: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }
  renderTo() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('To', {
              defaultValue: '',
              placeholder: '',
              required: true,
              id: 'to',
              value: this.state.toSelector,
              onChange: e => {
                this.setState({ toSelector: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }

  renderTeam() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Team</ControlLabel>
        <Select
          placeholder={__('Search')}
          onFocus={() => this.handleTeamSearch('')}
          onInputChange={this.handleTeamSearch}
          onChange={selectedOption => {
            this.setState({
              selectedTeam: selectedOption
            });
          }}
          value={this.state.selectedTeam}
          options={this.generateProjectParams(this.state.TeamList)}
          multi
        />
      </FlexItem>
    );
  }

  renderUser() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>User</ControlLabel>
        <Select
          placeholder={__('Search')}
          onFocus={() => this.handleUserSearch('')}
          onInputChange={this.handleUserSearch}
          onChange={selectedOption => {
            this.setState({
              selectedUser: selectedOption
            });
          }}
          value={this.state.selectedUser}
          options={this.generateProjectParams(this.state.UserList)}
          multi
        />
      </FlexItem>
    );
  }
  // sms sender dropdown
  renderSender() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Sender</ControlLabel>
        <Select
          placeholder={'Select Sender'}
          onFocus={() => this.handleSenderSelect('')}
          onInputChange={this.handleSenderSelect}
          onChange={selectedOption => {
            this.setState({
              selectedSenderList: selectedOption
            });
          }}
          value={this.state.selectedSenderList}
          options={this.generateProjectParams(this.state.senderList)}
          
        />
      </FlexItem>
    );
  }

  resetAllData() {
    let tData = Object.assign({}, this.setState({
      startDate: '',
      endDate: '',
      // freeTextSearch: '',
      // fromSelector: '',
      // toSelector: '',
      DatesBy: '',
      selectedSenderList: {value: "", label: ""},
      showStartEndDate:false
    }));
    // this.setState({
    //   startDate: '',
    //   endDate: '',
    //   freeTextSearch: '',
    //   fromSelector: '',
    //   toSelector: ''
    // });

    console.log('tData', tData);
    this.props.getData(tData);
  }

  checkField(field) {
    const { filterList = [] } = this.props;
    console.log(this.props);
    return filterList && filterList.indexOf(field) > -1 ? true : false;
  }
  render() {
    const { __ } = this.context;
    const props = {
      inputProps: { placeholder: __('Click to select a date') },
      timeFormat: 'HH:mm',
      dateFormat: 'YYYY/MM/DD',
      direction: "up"
      
    };
    let zone = {};
    if (window.localStorage && window.localStorage.getItem('timezone')) {
      zone = JSON.parse(window.localStorage.getItem('timezone'));
    } else {
      zone = { value: 'America/New_York', label: 'America/New_York' };
    }
    // const importeditTrigger = (
    //   <Button
    //     btnStyle="default"
    //     icon="add"
    //     size="medium"
    //     style={{ marginLeft: '10px', marginRight: '10px' }}
    //   >
    //     Save Filter
    //   </Button>
    // );

    return (
      <InsightFilter>
        {/* <InsightTitle>{this.props.showButton()}</InsightTitle> */}
        <FlexRow>
        {this.checkField("renderSender") && this.renderSender()}
          {this.checkField("renderUser") && this.renderUser()}
          {" "}
          {/* {this.props.history.location.pathname === "/dashboard" && <React.Fragment> */}
          <FlexItem>
              <ControlLabel>Select By Date</ControlLabel>
              <Select
                key={`${uuid.v4()}entity`}
                value={this.state.DatesBy}
                defaultValue={'Date'}
                placeholder={'Dates'}
                options={this.generateEntitysParams([
                  'Today',
                  'Yesterday',
                  'Last 7 Days',
                  'Current Month',
                  'Last Month',
                  'Custom Date'
                ])}
                onChange={items => {
                  let selected = '';

                  if (
                    items &&
                    typeof items !== 'undefined' &&
                    window.localStorage
                  ) {
                    selected = items.value;
                    let zone = JSON.parse(
                      window.localStorage.getItem('timezone')
                    );
                    this.setState({
                      DatesBy: selected
                    });

                    if (selected === 'Today') {
                      let mStartDate =
                        parseInt(
                          moment()
                            .startOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let date =
                        parseInt(
                          moment()
                            .endOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let mStartTimeStamp = mStartDate;
                      let mEndTimeStamp = date;
                      this.setState({
                        startDate: mStartTimeStamp,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false
                      });
                    } else if (selected === 'Last 7 Days') {
                      // let dateObj = new Date();
                      let mStartDate =
                        parseInt(
                          moment()
                            .subtract(7, 'days')
                            .startOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let date =
                        parseInt(
                          moment()
                            .tz(zone.value)
                            .endOf('day')
                            .format('X')
                        ) * 1000;
                      let mStartTimeStamp = mStartDate;
                      let mEndTimeStamp = date;

                      // subtract one day from current time
                      this.setState({
                        startDate: mStartTimeStamp,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false
                      });
                    } else if (selected === 'Yesterday') {
                      // let dateObj = new Date();
                      let mStartDate =
                        parseInt(
                          moment()
                            .subtract(1, 'days')
                            .startOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let date =
                        parseInt(
                          moment()
                            .subtract(1, 'days')
                            .endOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let mStartTimeStamp = mStartDate;
                      let mEndTimeStamp = date;

                      // subtract one day from current time
                      this.setState({
                        startDate: mStartTimeStamp,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false
                      });
                    }
                    else if (selected === 'Current Month') {
                      let mStartDate =
                        parseInt(
                          moment()
                            .startOf('month')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let mEndTimeStamp =
                        parseInt(
                          moment()
                            .endOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      this.setState({
                        startDate: mStartDate,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false
                      });
                    } else if (selected === 'Last Month') {
                      let lastMonthStartDate =
                        parseInt(
                          moment()
                            .subtract(1, 'month')
                            .startOf('month')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let lastMonthEndDate =
                        parseInt(
                          moment()
                            .subtract(1, 'month')
                            .endOf('month')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      this.setState({
                        startDate: lastMonthStartDate,
                        endDate: lastMonthEndDate,
                        showStartEndDate: false
                      });
                    } else if (selected === 'Custom Date') {
                      let dateObj =
                        parseInt(
                          moment()
                            .subtract(1, 'days')
                            .startOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      this.setState({
                        startDate: dateObj,
                        endDate:
                          parseInt(
                            moment()
                              .endOf('day')
                              .tz(zone.value)
                              .format('X')
                          ) * 1000,
                        showStartEndDate: true
                      });
                    }
                  } else {
                    // let dateObj =
                    //   parseInt(
                    //     moment()
                    //       .subtract(30, 'days')
                    //       .startOf('day')
                    //       .tz(zone.value)
                    //       .format('X')
                    //   ) * 1000;
                    // let date =
                    //   parseInt(
                    //     moment()
                    //       .endOf('day')
                    //       .tz(zone.value)
                    //       .format('X')
                    //   ) * 1000;
                    this.setState({
                      startDate: "",
                      endDate: ""
                    });
                  }
                  this.setState({
                    DatesBy: selected
                  });
                }}
              />

            </FlexItem>
            
          {this.state.showStartEndDate && this.state.toshowGroupby !== 2 && (
            <FlexItem>
              <ControlLabel>Start Date</ControlLabel>
              <Datetime
                className='datetimepicker'
                {...props}
                value={this.state.startDate}
                onBlur={this.onFilterByDate.bind(this, 'startDate')}
                onChange={date => {
                  this.setState({
                    startDate:
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format('X')
                      ) * 1000
                  });
                }}
              />
            </FlexItem>
          )}
          {this.state.toshowGroupby !== 2 && this.state.showStartEndDate && (
            <FlexItem>
              <ControlLabel>End date</ControlLabel>
              <Datetime
                {...props}
                value={this.state.endDate}
                onBlur={this.onFilterByDate.bind(this, 'endDate')}
                onChange={date => {
                  this.setState({
                    endDate:
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format('X')
                      ) * 1000
                  });
                }}
              />
            </FlexItem>
          )}
          {/* </React.Fragment>
          } */}

          {this.props.history.location.pathname === "/campaign" && <FlexItem>
              <ControlLabel>Select Date Time</ControlLabel>
              <Datetime
                className='datetimepicker'
                {...props}
                value={this.state.startDate}
                onBlur={this.onFilterByDate.bind(this, 'startDate')}
                onChange={date => {
                  this.setState({
                    startDate:
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format('X')
                      ) * 1000
                  });
                  this.onClick();
                }}
              />
            </FlexItem>
            }
          {this.checkField("renderFreeText") && (this.state.toshowGroupby === 0 ||
            this.state.toshowGroupby === 1 ||
            this.state.toshowGroupby === 4) && (
              <FlexItem>
                <FormWrapper>
                  <FormColumn>
                    {this.renderFormGroup('Free Text Search', {
                      defaultValue: '',
                      placeholder: '',
                      required: true,
                      id: 'freeTextSearch',
                      value: this.state.freeTextSearch,
                      onChange: e => {
                        this.setState({ freeTextSearch: e.target.value });
                      }
                    })}
                  </FormColumn>
                </FormWrapper>
              </FlexItem>
              )}
          {(this.state.toshowGroupby === 1 ||
            this.state.toshowGroupby === 4) && (
              <FlexItem>
                <ControlLabel>Group By</ControlLabel>
                <Select
                  key={`${uuid.v4()}entity`}
                  value={this.state.GroupBy}
                  defaultValue={'Call Date'}
                  placeholder={__('Select to GroupBy')}
                  options={this.generateEntitysParams([
                    'Call Date',
                    'InterMedia',
                    'Promo Code',
                    'Radial Error',
                    'DNIS',
                    'Creative Code'
                  ])}
                  onChange={items => {
                    let selected = '';
                    if ( items && items.value ) {
                      selected = items.value;
                    }
                    if (selected !== 'Call Date') {
                      let mStartDate =
                        parseInt(
                          moment()
                            .startOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let date =
                        parseInt(
                          moment()
                            .endOf('day')
                            .tz(zone.value)
                            .format('X')
                        ) * 1000;
                      let mStartTimeStamp = mStartDate;
                      let mEndTimeStamp = date;
                      this.setState({
                        startDate: mStartTimeStamp,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false,
                        GroupBy: selected
                      });
                    } else {
                      this.setState({
                        GroupBy: selected
                      });
                    }
                    console.log(this.state.GroupBy);
                  }}
                />
              </FlexItem>
            )}
        </FlexRow>
        <br />
        {this.props.history.location.pathname !== "/campaign" ? <FlexRow style={{ textAlign: 'end' }}>
          <FlexItem>
            <Button
              btnStyle="default"
              // icon="filter"
              onClick={this.onClick}
              size="medium"
            >
              Submit
            </Button>

            <Button
              btnStyle="simple"
              icon="refresh"
              onClick={this.resetAllData}
              size="medium"
              style={{ marginLeft: '10px' }}
            >
              Reset
            </Button>
          </FlexItem>
        </FlexRow>
        : <React.Fragment></React.Fragment>}
      </InsightFilter>
    );
  }
}

Filter.propTypes = propTypes;
Filter.contextTypes = contextTypes;

export default Filter;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/Filter.js